NHS.Scripts.Search = function (typeAheadUrl, callInitialize, functionAutoCompleteSelect, parameters) {
    this._typeAheadUrl = typeAheadUrl;   
    this.alreadyiInitialize = false;
    this._parameters = parameters;
    callInitialize = (typeof callInitialize === 'undefined') ? true : callInitialize;
    if (callInitialize) {
        this.initialize();
    }

    this.AutoCompleteSelect = functionAutoCompleteSelect;
};


NHS.Scripts.Search.prototype =
{
    initialize: function () {
        var self = this;
        if (self.alreadyiInitialize == false) {

            jQuery('#SearchText').on('focus', function () {
                jQuery('#nhs_HomeSearchOptions').slideDown(250, function () {
                    jQuery('#nhs_HomeSearchOptions > fieldset').fadeIn(1000);
                });
            });
            jQuery('#SearchTextCms').on('focus', function () {
                jQuery('#nhs_HomeSearchOptionsCms').slideDown(250, function () {
                    jQuery('#nhs_HomeSearchOptionsCms > fieldset').fadeIn(1000);
                });
            });

            jQuery('#PriceLow, #PriceHigh, #PriceLowCms, #PriceHighCms').on('focus', function () {
                var control = jQuery(this);
                if (!control.is('select') && control.val() != null && control.val().length != 0) {
                    control.priceFormat({
                        prefix: '$',
                        thousandsSeparator: ',',
                        centsLimit: 0,
                        insertPlusSign: false,
                        limit: 7
                    });
                }
            });

            jQuery('#PriceLow, #PriceHigh,#PriceLowCms, #PriceHighCms').on('blur', function () {
                var control = jQuery(this);
                if (!control.is('select') && control.val() != null && control.val().length != 0) {
                    control.priceFormat({
                        prefix: '$',
                        thousandsSeparator: ',',
                        centsLimit: 0,
                        insertPlusSign: false,
                        limit: 7
                    });
                }
            });

            this.validateSearchBox(jQuery('#frmHomePageCms'), jQuery("#nhs_field_validation_error_homeCms"), jQuery('#SearchTextCms'), false);
            jQuery("#nhs_GlobalSearchNavSubmit").click(function () {
                //alert('#nhs_GlobalSearchNavSubmit');
                var validateFuncion = self.showErrorSearchTextMessage;
                var value = jQuery("#nhs_GlobalSearchNavLocation").val();
                if (!validateFuncion(value)) {
                    value = jQuery.trim(value);
                    if (value.length > 0 && value != "Enter Location or Community Name") {
                        jQuery.googlepush('Search Events', 'Search Action', 'Search - NavigationNew');
                        return true;
                    }
                }
                jQuery("#nhs_field_validation_error").show();
                var homepageSearchText = jQuery("#SearchText").val("");
                if (homepageSearchText)
                    homepageSearchText.val("");
                jQuery("#nhs_GlobalSearchNavSubmit").removeAttr("disabled");
                return false;
            });

            var megaMenuInputText = jQuery("#nhs_GlobalSearchNavLocation");
            self.validateSearchBox(megaMenuInputText.closest('form'), jQuery('span.field-validation-error'), megaMenuInputText, false);

            if (typeof self._parameters != 'undefined') {
                if (!self._parameters.isFromHomePage && !self._parameters.isFromErrorPage) {
                    self.closeSlideDownPanel();
                }
            }

            //SetTextBoxesDescriptions();
            self.alreadyiInitialize = true;
        }
    },

    showErrorSearchTextMessage: function (textInput) {
        var text = String(textInput).trim();
       
        var hasError = false;

        if (typeof text == "undefined"
            || text == "") {
            hasError = true;
        } else if (text.indexOf(',') == -1 && !isNaN(text) && new RegExp(/(?:^|[^\d])(\d{5})(?:$|[^\d])/mg).test(text) == false) {
            hasError = true;
        } else if ((text.split(',').length > 1 && (text.split(',')[0].trim() === "" || text.split(',')[1].trim() === "" || text.split(',')[1].trim().length < 2))) {
            hasError = true;
        } else if ((text.indexOf(',') == -1 && new RegExp("[a-zA-Z0-9 ]+$").test(text) == false)) {
            hasError = true;
        }
        return hasError;
    },

    validateSearchBox: function (formElement, errorDiv, searchText, useAlert) {        
        var self = this;
        jQuery(formElement).on('submit', function (e) {
            var text = jQuery(searchText.selector).val().trim();
            var innerSelf = self;
            if (innerSelf.showErrorSearchTextMessage(text)) {
                e.preventDefault();
                if (useAlert) {
                    alert("Enter a valid text to search");
                } else {
                    jQuery(errorDiv).show();
                }
                jQuery("#nhs_GlobalSearchNavLocation").val("");
                return false;
            }
            return true;
        });
    },
    setupSearchBox: function (textBoxName, typeElement, useAlert) {
        var self = this;
        useAlert = (typeof useAlert === 'undefined') ? false : useAlert;
        jQuery("#" + textBoxName).keypress(function () {
            jQuery(".field-validation-error").hide().addClass("resource-center-validation");
        });

        //Autocomplete
        var searchTextBox = jQuery('#' + textBoxName);
        //check search text box exists
        if (searchTextBox !== null && searchTextBox.length > 0) {

            self.validateSearchBox(searchTextBox.closest('form'), searchTextBox.closest('form').find('.field-validation-error'), searchTextBox, useAlert);

            searchTextBox.autocomplete({
                source: this._typeAheadUrl,
                select: function (event, ui) {
                    event.preventDefault();
                    var value = ui.item.Type;
                    var text = ui.item.Name;

                    const form = event.target.closest('form');
                    const typeInput = form.querySelector('[data-suggestion-type]');
                    const idInput = form.querySelector('[data-suggestion-id]');

                    if (typeInput) {
                      typeInput.value = ui.item.Type;
                    }

                    if (idInput) {
                      idInput.value = ui.item.Id;
                    }

                    jQuery("#" + typeElement).val(value);
                    jQuery("#" + textBoxName).val(text);
                    if (jQuery.isFunction(self.AutoCompleteSelect)) {
                        self.AutoCompleteSelect(value, text, self);
                    }
                },
                focus: function (event, ui) {
                    event.preventDefault();
                }
            }).data("ui-autocomplete")._renderItem = function (ul, item) {
                item.label = item.Name;
                item.label = item.label.replace(new RegExp("(?![^&;]+;)(?!<[^<>]*)(" + jQuery.ui.autocomplete.escapeRegex(this.term.trim()) + ")(?![^<>]*>)(?![^&;]+;)", "gi"), "<strong id='ui-id'>$1</strong>");

                if (item.label.indexOf(" in ") != -1)
                    item.label = item.label.substring(0, item.label.indexOf(" in ")) + "<span id='ui-id'> in " + item.label.substring(item.label.indexOf(" in ") + 4) + "</span>";

                return jQuery("<li></li>")
                .data("item.autocomplete", item)
                .append("<a>" + item.label + "</a>")
                .appendTo(ul);
            };
            searchTextBox.autocomplete().data("ui-autocomplete").menu.element.detach().appendTo(jQuery('#' + textBoxName).parent());
        }
    },

    closeSlideDownPanel: function () {
        // When user clicks out of the container hide the search options
        jQuery(document).mouseup(function(e) {
            var container = jQuery("#nhs_HomeSearchForm");          
            if (!container.is(e.target) // if the target of the click isn't the container...
                    && container.has(e.target).length === 0) // ... nor a descendant of the container
            {
                jQuery("#nhs_HomeSearchOptions").hide();
            }
            if (jQuery("#nhs_HomeSearchFormCms")) {
                container = jQuery("#nhs_HomeSearchFormCms");
                if (!container.is(e.target) // if the target of the click isn't the container...
                        && container.has(e.target).length === 0) // ... nor a descendant of the container
                {
                    jQuery("#nhs_HomeSearchOptionsCms").hide();
                }  
            }
            
        });
    }
};
